import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { PaginationState } from '@tanstack/react-table';
import { DeactivatedUserData } from '@/api';

interface DeactivatedUsersListState {
  deactivatedUsersList: DeactivatedUserData[];
  deactivatedUsersListRowCount: number;
  deactivatedUsersListPagination: PaginationState;
}

const initialState: DeactivatedUsersListState = {
  deactivatedUsersList: [],
  deactivatedUsersListRowCount: 0,
  deactivatedUsersListPagination: {
    pageIndex: 0,
    pageSize: 50
  }
};

const deactivatedUsersSlice = createSlice({
  name: 'deactivatedUsers',
  initialState: initialState,
  reducers: {
    setDeactivatedUsersList: (state, action: PayloadAction<DeactivatedUserData[]>) => {
      state.deactivatedUsersList = action.payload;
    },
    setDeactivatedUsersRowCount: (state, action: PayloadAction<number>) => {
      state.deactivatedUsersListRowCount = action.payload;
    },
    setDeactivatedUsersPagination: (state, action: PayloadAction<PaginationState>) => {
      state.deactivatedUsersListPagination = action.payload;
    }
  }
});

export const { setDeactivatedUsersList, setDeactivatedUsersRowCount, setDeactivatedUsersPagination } =
  deactivatedUsersSlice.actions;

export const selectDeactivatedUsersList = (state: RootState) => {
  return state.deactivatedUsers.deactivatedUsersList;
};
export const selectDeactivatedUsersRowCount = (state: RootState) => {
  return state.deactivatedUsers.deactivatedUsersListRowCount;
};
export const selectDeactivatedUsersPagination = (state: RootState) => {
  return state.deactivatedUsers.deactivatedUsersListPagination;
};

export const deactivatedUsersReducer = deactivatedUsersSlice.reducer;
